import { Input } from '@/components/ui/input'
import type { CustomFilterProps } from '../../types/data-table.types'

export function CustomFilter({
  columnId,
  columnTitle,
  value,
  onChange,
  config,
}: CustomFilterProps) {
  return (
    <div className="space-y-1">
      <label htmlFor={`filter-custom-${columnId}`} className="text-xs font-medium">
        {columnTitle}
      </label>
      <Input
        id={`filter-custom-${columnId}`}
        placeholder={config.filterPlaceholder || `Search in ${columnTitle}`}
        value={typeof value === 'string' ? value : ''}
        onChange={(e) => onChange(e.target.value || undefined)}
        className="w-full h-7 text-xs"
      />
    </div>
  )
}
